import Image from 'next/image';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useSettingsStore } from '@core/settings/store/settings';

export interface LogoProps {
  width?: number;
  height?: number;
}

const Logo = ({ width, height }: LogoProps) => {
  const { clientLogo } = useSettingsStore();
  const { t } = useTranslation();
  if (!clientLogo) return null;
  return (
    <div className="flex justify-center items-center">
      <Image
        style={{
          objectFit: 'contain',
        }}
        src={clientLogo || ''}
        alt={t('common.logoAlt')}
        height={width || 55}
        width={height || 120}
      />
    </div>
  );
};

export default Logo;
